<template>
  <q-page>
    <q-table
      :data="pending"
      :columns="columnsOnView()"
      row-key="id"
      flat
      :pagination.sync="server_pagination"
      :loading="loading"
      @request="request"
      :rows-per-page-options="[5, 10, 50, 100]"
    >
      <template v-slot:top>
        <q-input
          v-model="search"
          debounce="300"
          :placeholder="$t('search')"
          class="q-mb-md"
          clearable
          @keyup.enter="request({ pagination: server_pagination })"
        />
      </template>
      
      <q-tr slot="header" slot-scope="props" :props="props">
          <q-th v-for="col in props.cols" :key="col.name" :props="props">
              {{ $t(col.label) }}
          </q-th>
      </q-tr>

      <q-tr slot="body" slot-scope="props" :props="props">
        <q-td key="id" :props="props">
          {{ props.row.id }}
        </q-td>

        <q-td key="user" :props="props">
          {{ props.row.user }}
        </q-td>

        <q-td key="user_email" :props="props">
          {{ props.row.user_email }}
        </q-td>

        <q-td key="reward_product" :props="props">
          {{ props.row.reward_product }}
        </q-td>

        <q-td key="reward_product_title" :props="props">
          {{ props.row.reward_product_title }}
        </q-td>

        <q-td key="price" :props="props">
          {{ props.row.price }}
        </q-td>

        <q-td key="created_date" :props="props">
          {{ formatDate(props.row.created_date) }}
        </q-td>
        
        <q-td key="actions" :props="props">
          <q-btn flat color="positive" icon="check" label="Aprovar"
            @click="openJustificationModal(props.row, 'approve')" />

          <q-btn flat color="negative" icon="close" label="Reprovar"
            @click="openJustificationModal(props.row, 'reject')" />
        </q-td>
      </q-tr>
      <q-tr slot="bottom-row">
        <q-td colspan="100%">
            <q-btn
                flat
                round
                dense
                color="secondary"
                size="small"
                icon="fas fa-cog"
                @click="show_modal = true"
            >
                <q-tooltip>
                    {{ $t('configure_table_tooltip') }}
                </q-tooltip>
            </q-btn>
        </q-td>
      </q-tr>
    </q-table>

    <q-modal
			v-model="show_modal"
		>
			<q-modal-layout>
				<q-toolbar slot="header">
					<q-btn flat round dense @click="saveColumns()" icon="fas fa-times" />
					<q-toolbar-title>
						{{ $t('personalize_columns') }}
					</q-toolbar-title>
				</q-toolbar>

				<div class="layout-padding">
					<div class="row gutter-md">
						<div
							class="col-xs-12 col-sm-4"
							v-for="(column, index) in columns"
							:key="index"
							v-if="column.name !== 'actions' && column.name !== 'id'"
						>
							<q-checkbox v-model="column.show" :label="$t(column.label)" />
						</div>
					</div>

					<div class="row reverse gutter-md q-mt-md">
						<div class="col-xs-12 col-sm-3">
							<q-btn
								icon="fas fa-times"
								color="primary"
								class="fit"
								:label="$t('close')"
								@click="saveColumns()"
							/>
						</div>
					</div>
				</div>
			</q-modal-layout>
		</q-modal>

    <q-modal v-model="showJustificationModal" persistent v-if="showJustificationModal" size="md" :loading="loading" no-backdrop-dismiss no-esc-dismiss>
      <q-modal-layout class="q-px-md q-pb-md" v-if="!loading">
        <h4 class="q-mb-md">
          Justificativa para {{ selectedAction === 'approve' ? 'aprovação' : 'reprovação' }}
        </h4>

        <q-card-main>
          <q-input
            type="textarea"
            v-model="justification"
            :error="$v.justification.$error"
            placeholder="Justificativa pública"
            rows="4"
            autofocus
          />
          <q-input
            type="textarea"
            v-model="internal_comment"
            placeholder="Observação Interna"
            rows="4"
            class="q-mt-md q-w-100"
          />
        </q-card-main>

        <q-card-actions>
          <q-btn flat label="Cancelar" @click="closeJustificationModal" />
          <q-btn
            :color="selectedAction === 'approve' ? 'positive' : 'negative'"
            :label="selectedAction === 'approve' ? 'Aprovar' : 'Reprovar'"
            @click="selectedAction === 'approve' ? approve(selectedItem) : reject(selectedItem)"
          />
        </q-card-actions>
      </q-modal-layout>
      <q-modal-layout v-else class="row items-center justify-center">
        <q-spinner-dots :size="60" color="secondary"></q-spinner-dots>
      </q-modal-layout>
    </q-modal>
  </q-page>
</template>

<script>
import { mapGetters } from 'vuex'
import { date } from 'quasar'

export default {
  name: 'Approvals',
  data () {
    return {
      pending: [],
      columns: [
        { id: 1, name: 'id', label: '#', field: 'id', align: 'left', show: true },
        { id: 2, name: 'user', label: 'ID do Usuário', field: 'user', align: 'left', show: true },
        { id: 3, name: 'user_email', label: 'Email do Usuário', field: 'user_email', align: 'left', show: true },
        { id: 4, name: 'reward_product', label: 'Id do Produto', field: 'reward_product_id', align: 'left', show: true },
        { id: 5, name: 'reward_product_title', label: 'Título do Produto', field: 'reward_product_title', align: 'left', show: true },
        { id: 6, name: 'price', label: 'Valor', field: 'price', align: 'center', sortable: true, show: true },
        { id: 7, name: 'created_date', label: 'Data de Solicitação', field: 'created_date', align: 'center', sortable: true, show: true },
        { id: 8, name: 'actions', label: 'Ações', field: 'actions', align: 'right', show: true }
      ],
      server_pagination: {
        page: 1,
        rowsPerPage: 10,
        rowsNumber: 0,
        descending: false,
        sortBy: null,
      },
      search: '',
      loading: false,
      showJustificationModal: false,
      justification: '',
      internal_comment: '',
      selectedItem: null,
      selectedAction: 'approve', // 'approve' or 'reject'
      show_modal: false,
    }
  },

  computed: {
    ...mapGetters({
      access_token: 'common/access_token',
      pending_rewards_columns: 'datatable_columns/pending_rewards_columns',
    }),
  
    getHeader() {
        let headers = {}
        return headers = {
            headers: {
                'content-type': 'application/json',
                'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                'authorization': 'Bearer ' + this.access_token
            }
        }
    }
  },
  methods: {
    columnsOnView() {
      return this.columns.filter(c => this.pending_rewards_columns.includes(c.id))
    },

    request({ pagination }) {
      this.loading = true
      this.server_pagination = pagination

      const params = {
        page: pagination.page,
        page_size: pagination.rowsPerPage,
      }
      
      if (pagination.sortBy) {
        params.ordering = pagination.descending ? '-' + pagination.sortBy : pagination.sortBy
      }

      if (this.search) {
        params.search = this.search
      }

      this.$axios.get('admin_rewards_store/reward_user_redemption/', { ...this.getHeader, params })
        .then(response => {
          this.pending = response.data.results
          this.server_pagination.rowsNumber = response.data.count
        })
        .catch(e => {
          this.$q.notify({ color: 'negative', message: 'Erro ao carregar dados' })
        })
        .finally(() => {
          this.loading = false
        })
    },

    async approve (item) {
      this.$v.$touch()
      const { id } = item
      this.loading = true

      this.$axios.post(
        `admin_rewards_store/reward_user_redemption/${id}/approve/`,
        {
          justification: this.justification,
          internal_comment: this.internal_comment
        },
        this.getHeader
      )
        .then(async response => {
          this.$q.notify({ color: 'positive', message: `Aprovado: ${response.data.reward_product_title}` })

          this.closeJustificationModal()

          await this.request({ pagination: this.server_pagination })
        })
        .catch(e => {
          let message = 'Erro ao aprovar resgate'

          if (e.response && Object.values(e.response.data).length > 0) {
            message = Object.values(e.response.data)[0]
          }

          this.$q.notify({ color: 'negative', message: message})
        })
        .finally(() => {
          this.loading = false
        })
    },

    async reject (item) {
      this.$v.$touch()
      const { id } = item
      this.loading = true

      this.$axios.post(
        `admin_rewards_store/reward_user_redemption/${id}/reject/`,
        {
          justification: this.justification,
          internal_comment: this.internal_comment
        },
        this.getHeader
      )
        .then(async response => {
          this.$q.notify({ color: 'positive', message: `Rejeitado: ${response.data.reward_product_title}` })

          this.closeJustificationModal()

          await this.request({ pagination: this.server_pagination })
        })
        .catch(e => {
          let message = 'Erro ao rejeitar resgate'

          if (e.response && Object.values(e.response.data).length > 0) {
            message = Object.values(e.response.data)[0]
          }

          this.$q.notify({ color: 'negative', message: message})
          
        })
        .finally(() => {
          this.loading = false
        })
    },

    saveDatatableColumns() {
        if (this.columns.filter(c => c.show).length == 0)
            this.$store.dispatch('datatable_columns/SET_PENDING_REWARDS_COLUMNS', [this.columns.map(c => c.id)])
        else
          this.$store.dispatch('datatable_columns/SET_PENDING_REWARDS_COLUMNS', [this.columns.filter(c => c.show || c.name === 'actions').map(c => c.id)])
		},

    saveColumns() {
			this.show_modal = false
			this.saveDatatableColumns()
		},

    openJustificationModal (item, action) {
      this.selectedItem = item
      this.justification = ''
      this.showJustificationModal = true
      this.rejectionReason = ''
      this.selectedAction = action || 'approve'
    },

    closeJustificationModal () {
      this.showJustificationModal = false
      this.selectedItem = null
      this.justification = ''
      this.internal_comment = ''
    },

    submitRejection () {
      if (!this.rejectionReason.trim()) {
        this.$q.notify({ color: 'negative', message: 'Por favor, preencha a justificativa.' })
        return
      }
      this.$q.notify({
        color: 'negative',
        message: `Reprovado: ${this.selectedItem.nome}<br>Justificativa: ${this.rejectionReason}`,
        html: true
      })
      // Lógica de reprovação aqui
      this.closeJustificationModal()
    },

    formatDate(d) {
			if (d) {
				let format = ''

				switch (this.id_user_language_selected) {
					case 1:
					case 3:
            format = 'MM-DD-YYYY HH:mm'
            break
          default:
						format = 'DD/MM/YYYY HH:mm'
            break
				}

				return date.formatDate(d, format)
			}
		},
  },

  created() {
      if (this.pending_rewards_columns.length == 0) {
        this.$store.dispatch('datatable_columns/SET_PENDING_REWARDS_COLUMNS', [this.columns.map(c => c.id)])
      } else {
          this.columns = this.columns.map(c => {
              if (this.pending_rewards_columns.includes(c.id) || c.name === 'actions') return { ...c, show: true }
              else return { ...c, show: false }
          })
      }
  },
  mounted() {
    this.request({ pagination: this.server_pagination })
  },
  validations() {
        return {
            justification: { required: true }
        }
    }
}
</script>
